import React from 'react';
import './ReportIndex.css'; // Add your CSS file for styling

const ReportIndex = () => {
    return (
        <React.Fragment>
            <div className="page-content mt-4">
                <div className="container-fluid mt-5">
                    <div className="report-tiles">
                        <div className="tile">
                            <i className="ti-bar-chart"></i>
                            <span>Profit and Loss - by Month</span>
                        </div>
                        <div className="tile">
                            <i className="ti-bar-chart-alt"></i>
                            <span>Profit and Loss - by Year</span>
                        </div>
                        <div className="tile">
                            <i className="ti-tablet"></i>
                            <span>Balance Sheet - by Month</span>
                        </div>
                        <div className="tile">
                            <i className="ti-tablet"></i>
                            <span>Balance Sheet - by Year</span>
                        </div>
                        <div className="tile">
                            <i className="ti-user"></i>
                            <span>Debtors Ageing</span>
                        </div>
                        <div className="tile">
                            <i className="ti-money"></i>
                            <span>Creditors Ageing</span>
                        </div>

                        <div className="tile">
                            <i className="ti-user"></i>
                            <span>Sales by Customer</span>
                        </div>

                        <div className="tile">
                            <i className="ti-truck"></i>
                            <span>Purchases by Supplier</span>
                        </div>
                        <div className="tile">
                            <i className="ti-calendar"></i>
                            <span>Payroll by Month</span>
                        </div>
                        <div className="tile">
                            <i className="ti-calendar"></i>
                            <span>Payroll by Year</span>
                        </div>
                        <div className="tile">
                            <i className="ti-money"></i>
                            <span>Cashflow Analysis Report</span>
                        </div>
                        <div className="tile">
                            <i className="ti-calendar"></i>
                            <span>Adjusted Earning Report by Month</span>
                        </div>
                        <div className="tile">
                            <i className="ti-calendar"></i>
                            <span>Adjusted Earning Report by Year</span>
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default ReportIndex;
